import { useSearchParams } from "@remix-run/react";
import { CloseIcon } from "~/assets/icons/Close";

export const FilteredBy = ({
  filteredBy,
}: {
  filteredBy: Array<{ label: string; slug: string; key: string }>;
}) => {
  const [, setSearchParams] = useSearchParams();
  if (filteredBy.length === 0) {
    return null;
  }
  return (
    <div className="my-2 flex flex-row flex-wrap justify-center">
      {filteredBy
        .filter((f) => f !== undefined)
        .map((f) => {
          if (f) {
            return (
              <FilteredByTile
                title={f.label}
                key={f.key + f.label}
                onClick={() => {
                  setSearchParams(
                    (sp) => {
                      sp.delete(f.key, f.slug);
                      return sp;
                    },
                    { preventScrollReset: true },
                  );
                }}
              ></FilteredByTile>
            );
          }
          return null;
        })}
      <FilteredByTile
        title="Hreinsa síu"
        onClick={() => {
          setSearchParams(
            (sp) => {
              filteredBy.forEach((f) => {
                sp.delete(f.key);
              });
              return sp;
            },
            { preventScrollReset: true },
          );
        }}
      ></FilteredByTile>
    </div>
  );
};

const FilteredByTile = ({
  title,
  onClick,
}: {
  title: string;
  onClick: () => void;
}) => {
  return (
    <div
      className="m-2 flex h-10 cursor-pointer flex-row items-center gap-2 whitespace-nowrap  bg-[#EFD4D7] px-4 py-2 text-xs"
      onClick={onClick}
    >
      {title} <CloseIcon size="16" />
    </div>
  );
};
